import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleClaimKmsSliderComponent } from '@shared/component/form-controls/slider/vehicle-claim-kms-slider/vehicle-claim-kms-slider.component';
import { MaterialModule } from '@shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@shared/directives/directives.module';

@NgModule({
  declarations: [
    VehicleClaimKmsSliderComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule
  ],
  exports: [
    VehicleClaimKmsSliderComponent
  ]
})
export class VehicleClaimKmsSliderModule { }
